import { render, staticRenderFns } from "./LogoGraphic.vue?vue&type=template&id=83feb9de&scoped=true&"
var script = {}
import style0 from "./LogoGraphic.vue?vue&type=style&index=0&id=83feb9de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83feb9de",
  null
  
)

export default component.exports